import React from "react";
import {ProductView} from "../components";

export const ProductPage: React.FC = () => <ProductView />;